import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-red",
  "use": "icon-user-red-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-red\">\n    <path d=\"M9.98 1.875a6.25 6.25 0 0 1 4.42 10.669l-.869-.9a5 5 0 1 0-.495.438v1.496A6.25 6.25 0 1 1 9.98 1.875zM1.62 18.273l-.878-.877 1.757-1.77v-.002h14.995l.005.005 1.76 1.76-.884.884-1.398-1.398H3.018l-1.397 1.398z\" fill=\"#D91D22\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol